import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AdvertModule} from './modules/advert/advert.module';
import {AnalyticsModule} from './modules/analytics/analytics.module';
import {ClipsModule} from './modules/clips/clips.module';
import {CounterModule} from './modules/counter/counter.module';
import {HotkeysModule} from './modules/hotkeys/hotkeys.module';
import {PlayerComponent} from './player/player.component';
import {RootStoreModule} from './store/root-store.module';
import {BigPlayBtnComponent} from './ui/big-play-btn/big-play-btn.component';
import {BottomPanelComponent} from './ui/bottom-panel/bottom-panel.component';
import {ButtonsBarComponent} from './ui/bottom-panel/buttons-bar/buttons-bar.component';
import {CreateClipComponent} from './ui/bottom-panel/buttons-bar/create-clip/create-clip.component';
import {DownloadClipComponent} from './ui/bottom-panel/buttons-bar/download-clip/download-clip.component';
import {FullscreenBtnComponent} from './ui/bottom-panel/buttons-bar/fullscreen-btn/fullscreen-btn.component';
import {PlayBtnComponent} from './ui/bottom-panel/buttons-bar/play-btn/play-btn.component';
import {PopupComponent} from './ui/bottom-panel/buttons-bar/popup/popup.component';
import {QualitySelectorComponent} from './ui/bottom-panel/buttons-bar/quality-selector/quality-selector.component';
import {TimecodeComponent} from './ui/bottom-panel/buttons-bar/timecode/timecode.component';
import {VolumeBarComponent} from './ui/bottom-panel/buttons-bar/volume-bar/volume-bar.component';
import {ProgressBarComponent} from './ui/bottom-panel/progress-bar/progress-bar.component';
import {LoaderComponent} from './ui/loader/loader.component';
import {PlayerUiComponent} from './ui/player-ui/player-ui.component';
import {PosterComponent} from './ui/poster/poster.component';
import {TopPanelComponent} from './ui/top-panel/top-panel.component';
import {VideoPanelComponent} from './ui/video-panel/video-panel.component';
import {ConsoleComponent} from './ui/console/console.component';
import {HttpClientModule} from '@angular/common/http';
import {NgxsModule} from '@ngxs/store';
import {PlayerState} from './store/player.state';
import {PlayableFactoryService} from './ui/video-panel/playable-factory.service';
import {UiToPlayableService} from './engine/ui-to-playable.service';
import {WebsocketService} from './engine/websocket.service';
import {ApiService} from './engine/api/api.service';
import {AnalyticsService} from './modules/analytics/analytics.service';
import {SettingsStoreService} from './player/settings-store.service';
import {HotkeysService} from './modules/hotkeys/hotkeys.service';
import {CounterService} from './modules/counter/counter.service';
import {ClipsService} from './modules/clips/clips.service';
import {AnonsModule} from './modules/anons/anons.module';


@NgModule({
  declarations: [
    PlayerComponent,
    VideoPanelComponent,
    PlayerUiComponent,
    PosterComponent,
    TopPanelComponent,
    BigPlayBtnComponent,
    BottomPanelComponent,
    ProgressBarComponent,
    ButtonsBarComponent,
    QualitySelectorComponent,
    CreateClipComponent,
    FullscreenBtnComponent,
    PopupComponent,
    TimecodeComponent,
    DownloadClipComponent,
    VolumeBarComponent,
    PlayBtnComponent,
    LoaderComponent,
    ConsoleComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    RootStoreModule,
    CounterModule,
    AdvertModule,
    HotkeysModule,
    ClipsModule,
    AnalyticsModule,
    AnonsModule,
  ],
  providers: [
    PlayableFactoryService,
    UiToPlayableService,
    WebsocketService,
    ApiService,
    AnalyticsService,
    SettingsStoreService,
    HotkeysService,
    CounterService,
    ClipsService
  ],
  exports: [PlayerComponent]
})
export class PlayerModule {
}
